import type { ReactNode } from "react";

export function Spinner({ label }: { label: string }): ReactNode {
  return (
    <span className="spinner" role="status">
      <span className="spinner__ring" aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}

export function FullPage({ children }: { children: ReactNode }): ReactNode {
  return <main className="full-page">{children}</main>;
}
